//REACT
import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//Secciones
import Cabecera from "../CabeceraPie/Cabecera"
import PiePagina from "../CabeceraPie/PiePagina"

import Carrusel from "./sections/Carrusel"
import Planes from "./sections/Planes"

//import liveChat from "../Home/liveChat"
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function IndexHome() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    window.localStorage.clear()
    window.sessionStorage.clear()

  });
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Cabecera color="transparent" />
        <Carrusel />
        {/*<Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Sitio Web de Pruebas
          </DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              Estimado Usuario,
            </Typography>
            <Typography gutterBottom>
              El sitio web que está a punto de utilizar es de pruebas, los datos ingresados,  y los certificados que se puedan emitir no son útiles.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Entiendo, Cerrar Modal.
            </Button>
          </DialogActions>
        </Dialog>*/}
        <Planes />
      <PiePagina />
    </div>
  )
}
